import React from 'react'
import ReactMarkdown from 'react-markdown'
import { withRouter } from 'react-router-dom'
import UIkit from 'uikit'

// Components
import Modal from '../../UIkit/Modal'


class ModalHint extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
    }

    this.handleOnClick = this.handleOnClick.bind(this)
  }

  handleOnClick() {
    UIkit.modal('#modal-hint').hide()
  }

  render() {
    return (
      <Modal
        id={`modal-hint-${this.props.stepId}`}
        body={(
          <div>
            {(this.props.hints.length > 1) && (
              <div className="uk-position-top-center uk-position-medium">
                <ul className="uk-dotnav uk-text-center" data-uk-switcher="animation: uk-admination-slide-right-medium, uk-animation-slide-left-medium">
                  {this.props.hints.map((hint, index) => {
                    const className = (hint.sort_order === this.state.step) ? 'uk-active' : ('')
                    return (
                      <li className={className} key={hint.id}>
                        <a href="#" onClick={() => { this.setState({ step: hint.sort_order }); }}>{index}</a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
            <div className="uk-padding">
              <ul className="uk-switcher uk-margin">
                {this.props.hints.map((hint, index) => {
                  const className = (Object.keys(hint).includes('sort_order') === false || hint.sort_order === this.state.step) ? 'uk-active' : ('')
                  return (
                    <li className={className} key={hint.id}>
                      <h2 className="uk-text-center">{hint.title}</h2>
                      <div>
                        <ReactMarkdown
                          escapeHtml={false}
                          linkTarget="_blank"
                          source={hint.markdown}
                        />
                      </div>

                      { (this.state.step > 1) && (
                        <button
                          className="uk-button uk-button-secondary uk-button-small"
                          data-uk-switcher-item={index - 1}
                          onClick={() => { this.setState({ step: this.state.step - 1 }) }}
                          type="button"
                        >
                          Back
                        </button>
                      )}
                      { (this.state.step < this.props.hints.length) && (
                        <button
                          className="uk-button uk-button-secondary uk-button-small uk-align-right"
                          data-uk-switcher-item={index + 1}
                          onClick={() => { this.setState({ step: this.state.step + 1 }) }}
                          type="button"
                        >
                          Next
                        </button>
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        )}
      />
    )
  }
}

export default withRouter(ModalHint)
